import * as b from "react";
import { a as O } from "./_commonjsHelpers-BkfeUUK-.mjs";
var p = { exports: {} }, c = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var i = Object.getOwnPropertySymbols, y = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
function j(n) {
  if (n == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(n);
}
function g() {
  try {
    if (!Object.assign)
      return !1;
    var n = new String("abc");
    if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
      return !1;
    for (var r = {}, e = 0; e < 10; e++)
      r["_" + String.fromCharCode(e)] = e;
    var t = Object.getOwnPropertyNames(r).map(function(a) {
      return r[a];
    });
    if (t.join("") !== "0123456789")
      return !1;
    var o = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(a) {
      o[a] = a;
    }), Object.keys(Object.assign({}, o)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var P = g() ? Object.assign : function(n, r) {
  for (var e, t = j(n), o, a = 1; a < arguments.length; a++) {
    e = Object(arguments[a]);
    for (var s in e)
      y.call(e, s) && (t[s] = e[s]);
    if (i) {
      o = i(e);
      for (var f = 0; f < o.length; f++)
        v.call(e, o[f]) && (t[o[f]] = e[o[f]]);
    }
  }
  return t;
};
const d = /* @__PURE__ */ O(b);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _ = d, l = 60103;
c.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var u = Symbol.for;
  l = u("react.element"), c.Fragment = u("react.fragment");
}
var w = _.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = Object.prototype.hasOwnProperty, E = { key: !0, ref: !0, __self: !0, __source: !0 };
function m(n, r, e) {
  var t, o = {}, a = null, s = null;
  e !== void 0 && (a = "" + e), r.key !== void 0 && (a = "" + r.key), r.ref !== void 0 && (s = r.ref);
  for (t in r) h.call(r, t) && !E.hasOwnProperty(t) && (o[t] = r[t]);
  if (n && n.defaultProps) for (t in r = n.defaultProps, r) o[t] === void 0 && (o[t] = r[t]);
  return { $$typeof: l, type: n, key: a, ref: s, props: o, _owner: w.current };
}
c.jsx = m;
c.jsxs = m;
p.exports = c;
var S = p.exports;
export {
  S as j,
  P as o,
  d as r
};
//# sourceMappingURL=jsx-runtime-3tyXYecC.mjs.map
